import { render, staticRenderFns } from "./addBankcard.vue?vue&type=template&id=90cc06b4&scoped=true"
import script from "./addBankcard.vue?vue&type=script&lang=js"
export * from "./addBankcard.vue?vue&type=script&lang=js"
import style0 from "./addBankcard.vue?vue&type=style&index=0&id=90cc06b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cc06b4",
  null
  
)

export default component.exports